import {
  ReferenceManyField,
  Datagrid,
  TextField,
  DateField,
  NumberField,
  FunctionField,
} from 'react-admin';
import { Printing } from '../../types';
import { calculatePrintingProgress, NUMBER_FORMATS, DATETIME_FORMAT } from '../../utils';

export const MachinePrintingsList = () => {
  return (
    <ReferenceManyField reference="printings" target="machineId" label="Printings">
      <Datagrid rowClick="show" bulkActionButtons={false}>
        <TextField source="id" />
        <TextField source="orderId" label="Order" />
        <TextField source="foot" />
        <NumberField source="meters" options={NUMBER_FORMATS.meters} />
        <FunctionField
          label="Progress"
          render={(record: Printing) => calculatePrintingProgress(record)}
        />
        <NumberField source="totalLines" label="Total Lines" />
        <DateField source="startTime" showTime options={DATETIME_FORMAT} />
        <DateField source="endTime" showTime options={DATETIME_FORMAT} />
        <NumberField
          source="expectedWeight"
          label="Expected Weight"
          options={NUMBER_FORMATS.weight}
        />
        <NumberField source="weight" options={NUMBER_FORMATS.weight} />
      </Datagrid>
    </ReferenceManyField>
  );
};
